<template>
    <div class="tooltip-phone">
        <router-link
            :to="relationLink()"
            v-text="relation.full_name"
            target="_blank"
            v-if="!permission_link"
        />
        <link-if-permissions
            target="_blank"
            permissions="view-relations"
            :to="relationLink()"
            v-else
        >
            {{ relation.full_name }}
        </link-if-permissions>
        <p class="tooltiptext-phone" :class="toolTipClass">
            <span v-if="showLandline || showMobile">
                <a :href="'tel:' + mobile" v-if="showMobile">
                    {{ uLang('app.mobile') }}: {{ mobile }}
                </a>
                <a :href="'tel:' + landline" v-if="showLandline">
                    {{ uLang('app.phone_number') }}: {{ landline }}
                </a>
            </span>
            <span v-else>
                {{ uLang('app.no_number_available') }}
            </span>
        </p>
    </div>

</template>

<script>
export default {
    name: "name-telephone-field",
    props: {
        relation: {
            required: true
        },
        permission_link: {
            required: false,
            default: false
        }
    },
    computed: {
        toolTipClass() {
            return this.showMobile && this.showLandline ? 'top-two' : 'top-one'
        },
        hasFullMobileNumberAvailable() {
            return this.relation.hasOwnProperty('full_mobile') && this.relation.full_mobile !== null
        },
        hasFullLandlineNumberAvailable() {
            return this.relation.hasOwnProperty('full_phone_number') && this.relation.full_phone_number !== null
        },
        showMobile() {
            return (this.relation.mobile_call_code &&
                this.relation.mobile) || this.hasFullMobileNumberAvailable
        },
        showLandline() {
            return (this.relation.phone_number_call_code &&
                this.relation.phone_number) || this.hasFullLandlineNumberAvailable
        },
        mobile() {
            if (this.hasFullMobileNumberAvailable) {
                return this.relation.full_mobile
            }
            return this.relation.mobile_call_code + this.relation.mobile
        },
        landline() {
            if (this.hasFullLandlineNumberAvailable) {
                return this.relation.full_phone_number
            }
            return this.relation.phone_number_call_code + this.relation.phone_number
        },
    },
    methods: {
        relationLink() {
            return {
                name: 'admin.relations.view',
                params: {'id': this.relation.id}
            }
        },
    },
}
</script>

<style scoped>
a {
    display: inline-block;
}

.tooltip-phone {
    position: relative;
    display: inline-block;
}

.tooltip-phone .tooltiptext-phone {
    visibility: hidden;
    width: 225px;
    background-color: white;
    color: #5a458a;
    border: 1px solid #5a458a;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    left: 105%;
}

.top-one {
    top: -5px;
}

.top-two {
    top: -17px;
}

.tooltip-phone .tooltiptext-phone::after {
    content: " ";
    position: absolute;
    top: 50%;
    right: 100%; /* To the left of the tooltip */
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent black transparent transparent;
}


.tooltip-phone:hover .tooltiptext-phone {
    visibility: visible;
}
</style>
